/**
 * 会员权益
 */
import { integralService } from '@/api'
import { AsyncRequest } from '@/utils/request'
import { integralName } from '@/pages/config'
const state = {
  title: '积分商城',
  integralName,
  goodsIndexInfo: {},
  loading: false,
  finished: false // 是否全部加载完成
}

const getters = {
  title: state => state.title,
  finished: state => state.finished,
  loading: state => state.loading,
  integralName: state => state.integralName,
  goodsIndexInfo: state => state.goodsIndexInfo
}

const mutations = {
  upgoodsIndexinfo(state, info) {
    state.goodsIndexInfo = info
  }
}

const actions = {
  // 商城首页
  integralInfo({ commit }, data) {
    return AsyncRequest({
      loading: false,
      request: () => integralService.integralInfo(data),
      resolve: res => {
        commit(
          'upgoodsIndexinfo',
          res.userCreditAccount || {
            available: 0
          }
        )
      }
    })
  },
  // 积分明细
  acountDetail({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => integralService.acountDetail(payload),
      resolve: () => {}
    })
  },
  // 关系绑定
  inviteBind({ commit }, data) {
    console.log('执行绑定逻辑--------')
    return AsyncRequest({
      loading: true,
      request: () => integralService.inviteBind(data),
      resolve: info => console.log('绑定成功-------', info)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
